import styled from "styled-components";

interface IProps {
	onClick?: () => void;
	type?: "button" | "reset" | "submit";
	children: JSX.Element | string;
	className?: string;
	disabled?: boolean;
}

export const Button = ({
	onClick,
	children,
	type,
	className,
	disabled = false,
}: IProps) => {
	const onClickHandler = () => {
		if (onClick) {
			onClick();
		}
	};

	return (
		<StyledComponent
			onClick={onClickHandler}
			type={type || "button"}
			className={className}
			disabled={disabled}
		>
			{children}
		</StyledComponent>
	);
};

const StyledComponent = styled.button`
	background: rgba(255, 255, 255, 0.03);
	border: 1px solid rgba(255, 255, 255, 0.1);
	padding: 0.5rem;
	cursor: pointer;
	height: 40px;

	&:active {
		background-color: rgba(255, 255, 255, 0.1);
	}
`;
